var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"big-number text-center position-relative"},[_c('span',{staticClass:"font-500 d-block number large-number mx-auto"},[_vm._v(_vm._s(_vm.number))]),_c('label',{staticClass:"number-label font-weight-normal text-center"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }